import React from "react";
import { Drawer as MuiDrawer, Box, IconButton } from "@mui/material";
import { PropTypes } from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import CloseIcon from "@mui/icons-material/Close";

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    zIndex: 2001,
    [theme.breakpoints.down("sm")]: {
      width: "100vw"
    },
    [theme.breakpoints.up("sm")]: {
      width: ({ width }) => width
    }
  }
}));

const Drawer = ({ children, anchor, expanded, width, onClose }) => {
  const classes = useStyles({ width });
  return (
    <MuiDrawer
      classes={{
        paper: classes.drawerPaper
      }}
      open={expanded}
      anchor={anchor}
      variant="persistent"
    >
      {onClose && (
        <Box position="absolute" top={24} right={24}>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      )}
      {children}
    </MuiDrawer>
  );
};

export default Drawer;

Drawer.propTypes = {
  anchor: PropTypes.oneOf(["right", "left"]),
  onClose: PropTypes.func
};

Drawer.defaultProps = {
  anchor: "right",
  showCloseIcon: true,
  width: 444
};
